export default __webpack_public_path__ + "static/hubbub-01cc755bc134630e0060e4768abc5f9c.png";